import { render, staticRenderFns } from "./DownloadAppModal.vue?vue&type=template&id=a0d33a5e&scoped=true&lang=pug&"
import script from "./DownloadAppModal.vue?vue&type=script&lang=ts&"
export * from "./DownloadAppModal.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadAppModal.vue?vue&type=style&index=0&id=a0d33a5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d33a5e",
  null
  
)

export default component.exports